import { useNetworksStateContext } from "@l2r-front/l2r-networks"
import { EMPTY_QUERY_PARAM } from "@l2r-front/l2r-query"
import { sortCatalogChildTypes } from "@l2r-front/l2r-utils"

import { verticalSigningQueryKeys } from "./queryKeys"
import { useVerticalSigningQueries, useVerticalSigningQuery } from "./useVerticalSigningQuery"

export function useVerticalSignTypes(parent = EMPTY_QUERY_PARAM, config = {}) {
    const url = "vertical_sign_types/"
    const { selectedNetwork } = useNetworksStateContext()
    const { country } = selectedNetwork

    const parameters = {
        country,
        parent: parent || EMPTY_QUERY_PARAM,
    }

    const queryKey = verticalSigningQueryKeys.list(parameters)

    const { data, isLoading, isError, isFetching } = useVerticalSigningQuery(
        url,
        queryKey,
        parameters,
        {
            ...config,
            autoRefetch: true,
        },
    )

    if (data) {
        data.sort((a, b) => a.code.localeCompare(b.code))
        data.forEach(d => sortCatalogChildTypes(d))
    }

    return { data, isLoading, isError, isFetching }
}

export function useVerticalSignType(code, queryParameters, config = {}) {
    const url = `vertical_sign_types/${code}/`
    const queryKey = verticalSigningQueryKeys["verticalSignType"]({ ...queryParameters, code })

    const { data, isLoading, isError } = useVerticalSigningQuery(
        url,
        queryKey,
        { ...queryParameters },
        {
            enabled: !!code,
            ...config,
            autoRefetch: true,
        },
    )

    if (data) {
        sortCatalogChildTypes(data)
    }

    return { data, isLoading, isError }
}

export function useVerticalSignTypeQueries(verticalSigns = [], config = {}) {
    const uniqueTypes = [...new Set(verticalSigns.map(verticalSign => verticalSign.vertical_sign_type))]
    const queries = uniqueTypes.map(type => {
        const url = `vertical_sign_types/${type}/`
        const queryKey = verticalSigningQueryKeys["verticalSignType"](type)
        return ({
            url,
            queryKey,
            queryParameters: {},
            config: {
                ...config,
                autoRefetch: true,
            },
        })
    })

    return useVerticalSigningQueries(queries)
}